import React from 'react'
import styled from 'styled-components'

import PlaceholderContainer from 'commons/js/ui/PlaceholderContainer'
import { themeMediaQuery, getLocalizedSrc, useConfig } from '@elparking/components'

export const BottomBarWrapper = styled.div`
    z-index:3;
    position: fixed;
    bottom: 0px;
    height: ${({ expanded }) => expanded ? '100%' : '82px'};
    background-color: white;
    box-shadow: 0px -2px 8px 0px rgba(0,0,0,0.1);
    transition: height 0.3s ease-in-out;
    width: 100%;
    max-width: 100vw;
    align-items: center;
    justify-content: center;
    overflow-y: ${({ expanded }) => expanded ? 'scroll' : 'hidden'};
    ${themeMediaQuery('medium')} {
        display: none;
    }
    cursor: pointer;
`

const PlaceholderImage = styled.img`
    width: 100%;
    margin: 0 auto;
    max-height: 100%;
`

export const BottomBarPlaceholder = () => {
    const country = useConfig('country')
    const flavor = useConfig('flavor')
    const excludedFlavors = useConfig('excludedFlavors')
    return (
        <BottomBarWrapper>
            <PlaceholderContainer>
                <PlaceholderImage src={getLocalizedSrc('/images/booking-process/bottom-bar-placeholder.svg', country, flavor, excludedFlavors)} />
            </PlaceholderContainer>
        </BottomBarWrapper>
    )
}
